import { styled } from "@mui/material/styles";

const PageSubTitle = styled("p")(`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #475467;
  width: 55%;
  margin: 10px auto;
`);

export default PageSubTitle;
